<template>
    <div class="row">
        <div class="col-sm-12">
            <h1>Cancelled Orders</h1>
            <hr>
            <table class="table table-bordered table-striped">
                <thead>
                <tr>
                    <th width="100">Marketplace</th>
                    <th>Order ID</th>
                    <th>Buyer</th>
                    <th>Amount</th>
                    <th>Items</th>
                    <th>Status</th>
                    <th width="180"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="!orders.length">
                    <td colspan="7" class="text-center">
                        No Orders found
                    </td>
                </tr>
                <tr v-for="order in orders" v-if="orders.length">
                    <td class="text-center"><img v-bind:src="`/images/integrations/${order.integration.marketplace.code}/table-icon.png`" class="img-responsive" /></td>
                    <td>{{ order.order_number }}</td>
                    <td>{{ order.shipping_address.first_name }} {{ order.shipping_address.last_name }}</td>
                    <td>${{ order.total_price }}</td>
                    <td>
                        {{ order.items.length }}
                    </td>
                    <td>{{ order.order_status.name }}</td>
                    <td class="text-center">
                        <router-link :to="`/orders/${order.id}`" class="btn btn-info btn-sm">
                            View
                        </router-link>
                        <router-link to="/orders/new-shipment" class="btn btn-primary btn-sm">
                            Ship
                        </router-link>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="pagination" v-if="pagination.last_page > 1">
                <button class="btn btn-primary" @click="fetchOrders(pagination.prev_page_url)"
                        :disabled="!pagination.prev_page_url">
                    Previous
                </button>
                <span>Page {{pagination.current_page}} of {{pagination.last_page}}</span>
                <button class="btn btn-primary" @click="fetchOrders(pagination.next_page_url)"
                        :disabled="!pagination.next_page_url">Next
                </button>
            </div>
        </div>
    </div>
</template>


<script>
    export default {

        data () {
            return {
                orders: [],
                pagination: {}
            };
        },
        created() {
            //this.fetchOrders();
        },
        methods: {
            fetchOrders: function (page_url = '/orders?ajax=true') {
                let vm = this;
                axios.get(page_url)
                    .then(function (response) {
                        vm.makePagination(response.data)
                        vm.orders = response.data.data;
                    });
            },
            makePagination: function (data) {
                this.pagination = {
                    current_page: data.current_page,
                    last_page: data.last_page,
                    next_page_url: data.next_page_url,
                    prev_page_url: data.prev_page_url
                };
            },
            sync: function(e) {
                let methods = this;
                axios.get('/sync')
                    .then(function (response) {
                        methods.fetchOrders();
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/Orders/Cancelled.vue